"use strict";
// Copyright (C) 2017-2025 Smart code 203358507
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var components_1 = require("stremio/components");
var common_1 = require("stremio/common");
var useCatalogPreferences_1 = require("stremio/common/useCatalogPreferences");
var components_2 = require("../components");
var useHomeScreenOptions_1 = __importDefault(require("./useHomeScreenOptions"));
var HomeScreen_less_1 = __importDefault(require("./HomeScreen.less"));
var HomeScreen = (0, react_1.forwardRef)(function (_a, ref) {
    var profile = _a.profile;
    var t = (0, common_1.useTranslate)();
    var _b = (0, useHomeScreenOptions_1.default)(), heroSectionEnabledToggle = _b.heroSectionEnabledToggle, getCatalogToggle = _b.getCatalogToggle, getCatalogHeroButton = _b.getCatalogHeroButton, reorderCatalogs = _b.reorderCatalogs, catalogs = _b.catalogs;
    var _c = (0, react_1.useState)(null), draggedIndex = _c[0], setDraggedIndex = _c[1];
    var _d = (0, react_1.useState)(null), dragOverIndex = _d[0], setDragOverIndex = _d[1];
    var orderedCatalogs = (0, react_1.useMemo)(function () {
        // Use catalog order from preferences, fallback to original order
        var catalogIds = catalogs.map(function (c) { return (0, useCatalogPreferences_1.getCatalogId)(c); }).filter(function (id) { return id !== null; });
        var order = reorderCatalogs.getCatalogOrder();
        if (order.length > 0) {
            // Sort by order array
            var ordered = __spreadArray([], catalogs, true).sort(function (a, b) {
                var idA = (0, useCatalogPreferences_1.getCatalogId)(a);
                var idB = (0, useCatalogPreferences_1.getCatalogId)(b);
                if (!idA || !idB)
                    return 0;
                var indexA = order.indexOf(idA);
                var indexB = order.indexOf(idB);
                if (indexA === -1 && indexB === -1)
                    return 0;
                if (indexA === -1)
                    return 1;
                if (indexB === -1)
                    return -1;
                return indexA - indexB;
            });
            return ordered;
        }
        return catalogs;
    }, [catalogs, reorderCatalogs]);
    var handleDragStart = (0, react_1.useCallback)(function (e, index) {
        setDraggedIndex(index);
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/html', '');
    }, []);
    var handleDragOver = (0, react_1.useCallback)(function (e, index) {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
        setDragOverIndex(index);
    }, []);
    var handleDragLeave = (0, react_1.useCallback)(function () {
        setDragOverIndex(null);
    }, []);
    var handleDrop = (0, react_1.useCallback)(function (e, dropIndex) {
        e.preventDefault();
        if (draggedIndex === null || draggedIndex === dropIndex) {
            setDraggedIndex(null);
            setDragOverIndex(null);
            return;
        }
        var draggedCatalog = orderedCatalogs[draggedIndex];
        var newOrder = __spreadArray([], orderedCatalogs, true);
        newOrder.splice(draggedIndex, 1);
        newOrder.splice(dropIndex, 0, draggedCatalog);
        var catalogIds = newOrder.map(function (c) { return (0, useCatalogPreferences_1.getCatalogId)(c); }).filter(function (id) { return id !== null; });
        reorderCatalogs.setCatalogOrder(catalogIds);
        setDraggedIndex(null);
        setDragOverIndex(null);
    }, [draggedIndex, orderedCatalogs, reorderCatalogs]);
    return (react_1.default.createElement(components_2.Section, { ref: ref, label: 'SETTINGS_NAV_HOME_SCREEN' },
        react_1.default.createElement(components_2.Option, { label: 'SETTINGS_HOME_SCREEN_ENABLE_HERO' },
            react_1.default.createElement(components_1.Toggle, __assign({ tabIndex: -1 }, heroSectionEnabledToggle))),
        react_1.default.createElement(components_2.Category, { icon: 'grid', label: 'SETTINGS_HOME_SCREEN_CATALOGS' }, orderedCatalogs.length === 0 ? (react_1.default.createElement("div", { className: HomeScreen_less_1.default['empty-state'] }, t.string('SETTINGS_HOME_SCREEN_NO_CATALOGS'))) : (orderedCatalogs.map(function (catalog, index) {
            var catalogId = (0, useCatalogPreferences_1.getCatalogId)(catalog) || "catalog-".concat(Math.random());
            var catalogTitle = t.catalogTitle(catalog) || 'Unknown Catalog';
            var catalogToggle = getCatalogToggle(catalog);
            var heroButton = getCatalogHeroButton(catalog);
            var isDragging = draggedIndex === index;
            var isDragOver = dragOverIndex === index;
            return (react_1.default.createElement("div", { key: catalogId, className: "".concat(HomeScreen_less_1.default['catalog-item'], " ").concat(isDragging ? HomeScreen_less_1.default['dragging'] : '', " ").concat(isDragOver ? HomeScreen_less_1.default['drag-over'] : ''), draggable: true, onDragStart: function (e) { return handleDragStart(e, index); }, onDragOver: function (e) { return handleDragOver(e, index); }, onDragLeave: handleDragLeave, onDrop: function (e) { return handleDrop(e, index); } },
                react_1.default.createElement("div", { className: HomeScreen_less_1.default['catalog-content'] },
                    react_1.default.createElement("div", { className: HomeScreen_less_1.default['drag-handle'], title: t.string('SETTINGS_HOME_SCREEN_DRAG_HANDLE') },
                        react_1.default.createElement("div", { className: HomeScreen_less_1.default['drag-handle-icon'] })),
                    react_1.default.createElement("div", { className: HomeScreen_less_1.default['catalog-title'], title: catalogTitle }, catalogTitle),
                    react_1.default.createElement("div", { className: HomeScreen_less_1.default['catalog-controls'] },
                        react_1.default.createElement(components_1.Button, { className: "".concat(HomeScreen_less_1.default['hero-button'], " ").concat(heroButton.checked ? HomeScreen_less_1.default['hero-active'] : '', " ").concat(heroButton.disabled ? HomeScreen_less_1.default['disabled'] : ''), title: t.string('SETTINGS_HOME_SCREEN_SHOW_IN_HERO'), onClick: heroButton.onClick, disabled: heroButton.disabled, tabIndex: -1 },
                            react_1.default.createElement("span", { className: HomeScreen_less_1.default['hero-label'] }, t.string('HERO'))),
                        react_1.default.createElement(components_1.Toggle, __assign({ className: HomeScreen_less_1.default['catalog-toggle'], tabIndex: -1 }, catalogToggle))))));
        })))));
});
exports.default = HomeScreen;
